<template>
  <nav class="location-tabs mb-3">
    <ul class="nav nav-pills d-none d-lg-flex">
      <li @click="selectAll(true)" class="nav-item flex-center mr-0 mr-md-2" title="See all routes">
        <button @click.prevent :class="{active: allSelected}" class="nav-link cursor-pointer all-selected btn btn-link">All</button>
      </li>
      <li @click="daySelected(day)" v-for="day in days" :key="day" class="nav-item flex-center" :title="`Select routes for ${day.name}`">
        <button @click.prevent :class="{active: activeDay === day.name}" class="nav-link cursor-pointer btn btn-link">{{day.name}}</button>
      </li>
      <li @click="selectUnassigned(true)" class="nav-item flex-center ml-0 ml-md-4" title="See unassigned routes">
        <button @click.prevent :class="{active: unassignedSelected === true}" class="nav-link cursor-pointer btn btn-link">Unassigned</button>
      </li>
    </ul>

    <select @change="onSelect($event)" v-model="activeDay" class="form-control d-flex d-lg-none mt-3 mt-lg-0">
      <option disabled>Select Day..</option>
      <option value="All">All</option>
      <option v-for="day in days" :key="day.name" :value="day.name">{{day.name}}</option>
      <option value="Unassigned">Unassigned</option>
    </select>
  </nav>
</template>

<script>
  export default {
    data() {
      return {
        days: [
          { name: 'Monday', dayIndex: 1 },
          { name: 'Tuesday', dayIndex: 2 },
          { name: 'Wednesday', dayIndex: 3 },
          { name: 'Thursday', dayIndex: 4 },
          { name: 'Friday', dayIndex: 5 },
          { name: 'Saturday', dayIndex: 6 },
          { name: 'Sunday', dayIndex: 0 },
        ],
        activeDay: 'Wednesday',
        allSelected: false,
        unassignedSelected: false,
        isFixed: false
      }
    },
    mounted() {
      this.setDefault()
    },
    methods: {
      setDefault() {
        if (this.$page.props.day == -1) this.selectAll()
        else if (this.$page.props.day == -2) this.selectUnassigned()
        else if (this.$page.props.day) {
          this.days.forEach(elem => {
            if (elem.dayIndex === Number(this.$page.props.day)) this.saveDay(elem)
          })
        } else this.selectAll()
      },
      onSelect(event) {
        if (event.target.value === 'All') this.selectAll(true)
        if (event.target.value === 'Unassigned') this.selectUnassigned(true)
        else {
          this.days.forEach(day => {
            if (day.name === event.target.value) this.daySelected(day)
          })
        }
      },
      getActiveDay() {
        // Selects day based on current date
        const date = new Date()
        this.days.forEach(elem => {
          if (elem.dayIndex === date.getDay()) this.saveDay(elem)
        })
      },
      daySelected(day) {
        this.updateDayState(day)
        this.$emit('daySelected', day)
      },
      saveDay(day) {
        this.updateDayState(day)
        this.$emit('saveDay', day)
      },
      updateDayState(day) {
        this.allSelected = false
        this.unassignedSelected = false
        this.activeDay = day.name
      },
      selectAll(clear=false) {
        this.activeDay = ''
        this.unassignedSelected = false
        this.allSelected = true
        this.$emit('selectAll', clear)
      },
      selectUnassigned(clear=false) {
        this.unassignedSelected = true
        this.allSelected = false
        this.activeDay = ''
        this.$emit('selectUnassigned', clear)
      }
    }
  }
</script>
